import JSONSerializer from '@ember-data/serializer/json';
import { underscore } from '@ember/string';
export default class Addon extends JSONSerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    return super.normalizeResponse(store, primaryModelClass, payload.data, id, requestType);
  }
}